<template lang="pug">
  b-container
    b-form-row.align-items-center.justify-content-end.mt-3.mb-4
      b-col(cols="auto")
        b-button(variant="primary", @click="openAttributeModal") Crear variable
    b-row
      //- b-col.order-md-2(md="4")
      //-   b-card
      //-     b-button(variant="success", block, @click="openAttributeModal()") Crear variable
      //-     hr
      //-     .text-help
      //-       alert-circle-icon.icon-md.mr-2
      //-       span Estas variables las va modificando el usuario en el curso del flujo y almacenan información temporalmente.
      b-col
        b-card(no-body, style="width:100%;")
          b-table.card-table.mb-0(:items="user_attributes", :fields="fields", responsive, show-empty, hover, @row-clicked="openAttributeModal")
            template(v-slot:empty)
              p.mb-0.text-secondary No hay variables creadas
            template(v-slot:cell(name)="{ item }")
              p.mb-0 {{ item.name }}
              p.text-help.mb-0 {{ item.description }}
            template(v-slot:cell(type)="{ item }")
              .uppercase {{ item.type }}
            template(v-slot:cell(createdAt)="{ item }")
              p.mb-0.text-secondary {{ $moment(item.createdAt).format('DD MMM YYYY') }}
            template(v-slot:cell(is_important)="{ item }")
              b-form-checkbox(switch, v-model="item.is_important", @change="updateUserAttributeValue(item.user_attribute_id, {is_important: $event})") {{item.is_important ? 'Sí' : 'No'}}
        .d-flex.align-items-center.mb-3
          b-pagination.mb-0.mr-3(:value="paginationCurrentPage", @change="loading = true;paginationPageChanged($event, 'getUserAttributes')", :per-page="v_paginationLimit", :total-rows="v_paginationItemsCount", v-if="v_paginationShow")
          b-spinner(small, variant="primary", v-if="loading")
    b-modal(v-model="attribute_modal", :ok-title="can_update ? 'Guardar' : 'Crear'", :ok-variant="can_update ? 'primary' : 'success'", cancel-title="Cancelar", :title="can_update ? 'Actualizar variable' : 'Crear variable'", @ok="can_update ? updateUserAttribute($event) : createUserAttribute($event)")
      b-form
        b-form-group(label="Nombre")
          b-form-input(placeholder="Nombre", v-model.trim="user_attribute.name", required, :state="!!user_attribute.name.length ? null : (validated ? false : null)")
        b-form-group(label="Descripción")
          b-form-textarea(placeholder="Descripción", v-model="user_attribute.description", max-rows="5", no-resize)
        b-form-group(label="Tipo de variable")
          b-form-select(v-model="user_attribute.type", :state="!!user_attribute.type ? null : (validated ? false : null)")
            option(value="", disabled) -- Seleccionar tipo --
            option(value="text") Texto
            option(value="object") Objeto JSON
      b-card.bg-light.text-center.text-sm.mb-0.mt-4(v-if="can_update")
        alert-triangle-icon.icon-sm.mr-2
        span Eliminar variable de cuenta, esta acción no se puede deshacer.
        p.mb-0.mt-2
          b-link.text-danger(@click="deleteUserAttribute") Eliminar variable
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
const userAttributeController = createNamespacedHelpers('user_attribute')

export default {
  data () {
    return {
      loading: false,
      fields: [
        {
          key: 'name',
          label: 'Variable'
        },
        {
          key: 'createdAt',
          label: 'Fecha de creación'
        },
        {
          key: 'is_important',
          label: 'Es importante'
        },
      ],
      attribute_modal: false,
      user_attribute : {
        name: '',
        description: '',
        type: '',
        user_attribute_id: null,
        is_important: false,
      },
      validated: false,
    }
  },
  computed: {
    ...userAttributeController.mapState({
      user_attributes: state => state.user_attributes
    }),
    can_update () {
      return !!this.user_attribute.user_attribute_id
    }
  },
  methods: {
    ...mapActions(['user_attribute/all', 'user_attribute/create', 'user_attribute/update', 'user_attribute/destroy']),
    getUserAttributes () {
      this.loading = true
      let self = this

      this['user_attribute/all']({
        account_id: self.$route.params.account_id,
        params: {
          ...self.paginationParamsObject,
        },
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.parsePaginationDataFromResponse(res)
          }
        }
      })
    },
    createUserAttribute (modal) {
      modal.preventDefault()
      if(!this.user_attribute.name.length || !this.user_attribute.type) {
        this.validated = true
        return
      }

      var self = this
      this['user_attribute/create']({
        account_id: self.$route.params.account_id,
        ...self.user_attribute,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.attribute_modal = false
          }
        }
      })
    },
    updateUserAttribute (modal) {
      modal.preventDefault()
      if(!this.user_attribute.name.length || !this.user_attribute.type) {
        this.validated = true
        return
      }

      var self = this
      this['user_attribute/update']({
        account_id: self.$route.params.account_id,
        ...self.user_attribute,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.attribute_modal = false
            self.$store.commit('user_attribute/updateItem', res.resource)
          }
        }
      })
    },
    deleteUserAttribute () {
      var self = this

      this.$bvModal.msgBoxConfirm(`¿Deseas eliminar la variable ${self.user_attribute.name}?`, {
        title: 'Eliminar variable',
        okTitle: 'Eliminar',
        okVariant: 'danger',
        cancelTitle: 'Cancelar'
      })
      .then(value => {
        if (value == true) {
          self['user_attribute/destroy']({
            account_id: self.$route.params.account_id,
            ...self.user_attribute,
            callback: res => {
              if (res.error) {
                self.$message.error(res.error)
              } else {
                self.attribute_modal = false
              }
            }
          })
        }
      })
      .catch(err => {
        // An error occurred
      })
    },
    openAttributeModal (attribute) {
      this.clearObject(this.user_attribute)
      this.validated = false
      this.user_attribute.user_attribute_id = null
      if (attribute) {
        this.user_attribute = Object.assign(this.user_attribute, attribute)
      }
      this.attribute_modal = true
    },
    updateUserAttributeValue (user_attribute_id, data) {
      var self = this
      this['user_attribute/update']({
        account_id: self.$route.params.account_id,
        user_attribute_id: user_attribute_id,
        ...data,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    }
  },
  mounted () {
    this.getUserAttributes()
  }
}
</script>

<style lang="scss" scoped>
</style>
